<template>
  <b-modal
    id="winnersModal"
    ref="winnersModal"
    title="우승자"
    centered>
    <div class="row">
      <div class="col">
        <p>상금 / 변환</p>
        <p class="h4">{{ room.prize }} coin/ {{ prizeConverted }} won</p>
      </div>
      <div class="col">
        <p>우승자/ 인당 상금 / 변환</p>
        <p class="h4">{{winnersCount()}}명 / {{ expectedPrize }} coin/ {{ expectedPrizeConverted }} won</p>
      </div>
    </div>
    <ul class="winners list-group" v-chat-scroll>
      <li class="winner list-group-item" v-for="w in winners.slice(0,20)" :key="w.id">
        <span class="h2">
          {{ w.nickname }}
        </span>
      </li>
    </ul>
  </b-modal>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import numToKor from '@/mixins/numToKor'
// import l from '@/vendor/logger'
// import * as _ from 'ramda'

export default {
  name: 'winnersModal',

  mixins: [numToKor],

  mounted () {
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters('user', [
      'isSignIn',
      'user'
    ]),
    ...mapState([
      'rid'
    ]),
    ...mapGetters('room', [
      'prizeKor',
      'prizeConverted',
      'prizeConvertedKor'
    ]),
    ...mapGetters('quizzes', [
      'latestNumberOfRight',
      'totalNumberOfQuizzes',
      'winners'
    ]),
    ...mapState('room', [
      'room'
    ]),
    expectedPrizeKor () {
      if (this.room.prize && this.latestNumberOfRight > 0) {
        return this.numToKor(
          this.room.prize / this.latestNumberOfRight
        )
      } else if (this.latestNumberOfRight === 0) {
        return this.numToKor(0)
      }
    },
    expectedPrize () {
      if (this.room.prize && this.latestNumberOfRight > 0) {
        const p = this.room.prize / this.latestNumberOfRight
        return parseInt(p * 10000) / 10000.0
      } else if (this.latestNumberOfRight === 0) {
        return this.numToKor(0)
      }
    },
    expectedPrizeConvertedKor () {
      if (this.room.prize && this.latestNumberOfRight && this.room.prizeRatio) {
        return this.numToKor(
          this.room.prize / this.latestNumberOfRight * this.room.prizeRatio
        )
      } else if (this.latestNumberOfRight === 0) {
        return this.numToKor(0)
      }
    },
    expectedPrizeConverted () {
      if (this.room.prize && this.latestNumberOfRight && this.room.prizeRatio) {
        const p = this.room.prize / this.latestNumberOfRight * this.room.prizeRatio
        return parseInt(p * 10000) / 10000.0
      } else if (this.latestNumberOfRight === 0) {
        return this.numToKor(0)
      }
    }
  },

  methods: {
    show () {
      this.$refs.winnersModal.show()
    },
    winnersCount () {
      if (this.winners) {
        return Object.keys(this.winners).length
      } else {
        return 0
      }
    }
  },
  watch: {
    room (val) {
      if (val.status === 'RESULT') {
        this.$refs.winnersModal.show()
      }
    }
  }
}
</script>

<style scoped>
.winners {
  overflow: scroll;
}
</style>
